<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">local_hospital</span>
      <p>
        Administra las especialidades médicas habilitadas para la empresa.
        Solo las especialidades activas estarán disponibles para asignar
        médicos, crear citas y registrar atenciones.
      </p>
    </div>

    <!-- Cómo funciona -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Cómo funciona
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in flujo" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Campos del formulario -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">edit_note</span>
        Campos del formulario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in campos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Estados -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Estados
      </h3>
      <div class="help-estados">
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">Activo</span>
        <span class="help-estado-badge" style="background:#e2e3e5;color:#383d41">Inactivo</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem;margin-top:0.5rem">
        Una especialidad <strong>Activa</strong> aparece en los selectores de
        médicos, citas y atenciones. Una especialidad <strong>Inactiva</strong>
        permanece en el historial pero no está disponible para nuevos registros.
      </p>
    </section>

    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Si necesitas deshabilitar una especialidad temporalmente, cámbiala
        a estado <strong>Inactivo</strong> en lugar de eliminarla. Así
        conservas el historial de atenciones asociadas sin que aparezca
        en los formularios activos.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaEspeEmpr",
  data() {
    return {
      flujo: [
        {
          icon: "table_rows",
          titulo: "Lista de especialidades",
          desc:   "Muestra todas las especialidades configuradas para la empresa con su nombre y estado actual.",
        },
        {
          icon: "add_circle",
          titulo: "Nueva especialidad",
          desc:   "Selecciona una especialidad del catálogo del sistema y asígnala a la empresa con el estado que corresponda.",
        },
        {
          icon: "edit",
          titulo: "Editar",
          desc:   "Permite cambiar la especialidad seleccionada o modificar su estado entre Activo e Inactivo.",
        },
      ],
      campos: [
        {
          icon: "local_hospital",
          titulo: "Especialidad",
          desc:   "Selecciona la especialidad médica del catálogo del sistema (medicina general, pediatría, ginecología, etc.).",
        },
        {
          icon: "toggle_on",
          titulo: "Estado",
          desc:   "Activo: la especialidad está disponible para citas y atenciones. Inactivo: queda oculta en los formularios pero conserva su historial.",
        },
      ],
      acciones: [
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nueva",
          desc:   "Abre el formulario para agregar una especialidad al catálogo de la empresa.",
        },
        {
          icon:   "edit",
          color:  "#198754",
          titulo: "Editar",
          desc:   "Permite modificar la especialidad o cambiar su estado.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Eliminar",
          desc:   "Elimina permanentemente la especialidad de la empresa. Si tiene atenciones o médicos asociados, considera usar el estado Inactivo en su lugar.",
        },
        {
          icon:   "download",
          color:  "#fd7e14",
          titulo: "Exportar Excel",
          desc:   "Descarga la lista de especialidades de la empresa en formato Excel.",
        },
        {
          icon:   "refresh",
          color:  "#6c757d",
          titulo: "Recargar",
          desc:   "Recarga la lista completa de especialidades de la empresa.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>